"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrgOptionMap = exports.OrgTierMap = exports.OrgPermissionMap = exports.ScriptStatusMap = void 0;
//
//   SCRIPT STATUS
//
exports.ScriptStatusMap = {
    OPEN: 'OPEN',
    LIMITED: 'LIMITED',
    PRIVATE: 'PRIVATE',
};
//
//   ORG PERMISSIONS
//
exports.OrgPermissionMap = {
    MODIFY_LIMITED_SCRIPT: 'MODIFY_LIMITED_SCRIPT',
    CHANGE_SCRIPT_STATUS: 'CHANGE_SCRIPT_STATUS',
    PUSH_TO_PROMPTER: 'PUSH_TO_PROMPTER',
    UPDATE_RUNDOWNS: 'UPDATE_RUNDOWNS',
    DESTROY_CONTENT: 'DESTROY_CONTENT',
};
//
//   ORG TIERS
//
exports.OrgTierMap = {
    FREE: 'free',
    NEW_MEDIA: 'new-media',
    TV_FILM: 'tv-film',
};
//
//   ORG OPTIONS
//
exports.OrgOptionMap = {
    SCRIPT_LIMITING: 'SCRIPT_LIMITING',
    PROMPTER_INTEGRATION: 'PROMPTER_INTEGRATION',
    PRIVATE_SCRIPTS: 'PRIVATE_SCRIPTS',
    RUNDOWNS: 'RUNDOWNS',
};
